import { store } from '../../components/_store'

import axios from 'axios'
import jwt from 'jsonwebtoken'

export const userService = {
    login,
    logout
}

function login(email, password) {
    let loginHeaders = {
        'Content-Type': 'application/json'
    }
    let loginBody = {
        email,
        password
    }

    return axios
        .post(`${store.state.authUrl}/login`, loginBody, loginHeaders)
        .then(response => {
            let user = response.data
            // login successful if there's a jwt token in the response
            if (user) {
                let mydecode = jwt.decode(user)
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                localStorage.setItem('user', JSON.stringify(user))
                let userdecode = {
                    userId: mydecode.user.userId,
                    firstName: mydecode.user.firstName,
                    lastName: mydecode.user.lastName,
                    fullName: mydecode.user.firstName + ' ' + mydecode.user.lastName,
                    email: mydecode.user.email,
                    companyId: mydecode.user.companyId,
                    role: mydecode.user.role
                }
                return userdecode
            } else {
                throw 'Something wrong'
            }
        })
        .catch(error => {
            console.log(error)

            let snackbarParams = {
                message: 'Login Failed',
                context: 'error'
            }
            store.commit('showSnackbar', snackbarParams)

            localStorage.clear()

            throw error
        })
}

function logout() {
    // remove user from local storage to log user out
    localStorage.clear()
}

//might be able to be removed, will take a look if this is used elsewhere during email refactor - Jonathan Jan 22/2020
function handleResponse(response) {
    const data = response.data
    if (response.statusText !== 'OK') {
        if (response.status === 401) {
            // auto logout if 401 response returned from api
            logout()
        }
        const error = (data && data.message) || response.statusText
        return Promise.reject(error)
    }
    return data
}
